<template>
  <div class="container users">
    <breadcrumb crumb="clients-settings" />
    <el-row>
      <el-col class="ta-r">
        <el-button type="primary" @click="setModal('clientModal', true)">
          Добавить клиента
        </el-button>
      </el-col>
    </el-row>
    <el-card style="width: 100%; margin-top: 40px">
      <el-table
        v-if="!loading || !list.length"
        ref="tableData"
        v-loading="loading"
        :data="list"
        style="width: 100%"
        row-class-name="u_row"
      >
        <el-table-column
          class-name="fio-class"
          label="Наименование"
          prop="short_name"
          header-align="left"
          align="left"
        />
        <el-table-column
          label="СЗВМ"
          prop="require_szvm_insurance_docs"
          sortable
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{ statusSZVM(list[scope.$index].require_szvm_insurance_docs) }}
          </template>
        </el-table-column>
        <el-table-column
          label="Описание"
          prop="description"
          sortable
          header-align="center"
          align="center"
        />
        <el-table-column align="right" label="Редактирование">
          <template slot-scope="scope">
            <el-button
              type="success"
              icon="el-icon-edit"
              class="no-events"
              circle
              @click="setModal('clientModal', true, list[scope.$index])"
            />
          </template>
        </el-table-column>
        <el-table-column label="" />
      </el-table>
      <br /><br />
      <el-row :gutter="24">
        <el-col :span="18">&nbsp;</el-col>
        <el-col :span="6">
          <section class="bottom-section">
            <div class="pagination">
              <pagination :data="pagination" @changed="changePage" />
            </div>
          </section>
        </el-col>
      </el-row>
    </el-card>

    <client-settings-modal
      :visible="clientModal"
      :client="client"
      @close="setModal('clientModal')"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { titles } from './constants'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import ClientSettingsModal from './components/ClientSettingsModal'
import Pagination from '@/components/Tables/PaginationCustom'

export default {
  name: 'ClientsSettings',
  components: { Breadcrumb, Pagination, ClientSettingsModal },
  data() {
    return {
      titles,
      clientModal: false,
      client: null,
      page: 1,
    }
  },
  computed: {
    ...mapGetters({
      loading: 'clients/getLoading',
      pagination: 'clients/getPagination',
      getClients: 'clients/getList',
    }),
    list() {
      return this.getClients()
    },
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions({ fetchClients: 'clients/fetchClients' }),
    statusSZVM(status) {
      if (String(status) === '1') {
        return 'требует СЗВМ'
      }
      if (String(status) === '0') {
        return 'не требует СЗВМ'
      }

      return 'не информации'
    },
    async loadPage() {
      await this.getList()
    },
    getList() {
      const { page } = this

      this.fetchClients({ page })
    },
    changePage(page = 1) {
      this.page = page
      this.getList()
    },
    setModal(key, flag = false, item = null) {
      this[key] = flag
      this.client = item
    },
  },
}
</script>

<style lang="sass">
.clients-settings
  font-size: 18px
  color: #000
  .title-row
    display: flex
    font-size: 14px
    text-align: center
    margin-top: 40px
  .clients
    margin: 20px 0
    background: #fff
    min-height: 80px
    padding: 15px 0
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
    .el-col
      text-align: center
      &.ta-left
        text-align: left
</style>
